module.exports = __webpack_public_path__ + "media/images/sp/specials/common/recommend_tokyo-6ec47b1f56e62eb719d266f6b1d4b3e3.jpg";